import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import type { ApplicationLinkOAuth2ConfigInfo } from './CommonApplicationLinkCreationEntity.tsx';

export const getOAuth2ConfigInfo = (id: string): Promise<ApplicationLinkOAuth2ConfigInfo> =>
	fetchJson(`/rest/applinks/3.0/applinks/${id}/oAuth2ConfigInfo`, {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
		},
	});
